export const isSameDomain = (loggedUserProviderId, checkedUserProviderId) => {
  return loggedUserProviderId === checkedUserProviderId;
};
